import { useMemo } from 'react';
import React from 'react';
import { Select } from '../../../../base-components/Select/index.js';
import { ExtraProps } from '../../../../base-components/Select/index.js';
import { useMatchesLabel } from '../../hooks/useMatchesLabel/index.js';
import { useMultipleValue } from '../../hooks/useMultipleValue.js';
import { IndicatorsContainer } from './components/IndicatorsContainer.js';
import { CustomProps } from './SelectRegion.type.js';
import { StaticProps } from './SelectRegion.type.js';

const staticProps: StaticProps = {
  components: {
    IndicatorsContainer,
    DropdownIndicator: null,
    IndicatorSeparator: null,
  },
};

interface Region {
  id: string | number;
  formalName: string;
  offName: string;
  regionCode: string;
  shortName: string;
}

interface RegionOption {
  value: string;
  label: string;
  matches?: number;
}

type RegionValue = { regionCode: string };

export interface Props {
  instanceId?: string;
  regions: Region[];
  value: RegionValue[];
  onChange: (value: Region[]) => void;
  onPlusClick: () => void;
  className?: string;
  appearance?: ExtraProps['appearance'];
  matches?: { [k: string]: number };
}

export const SelectRegions: React.FC<Props> = ({
  instanceId,
  regions,
  value,
  onChange,
  onPlusClick,
  className,
  appearance = 'default',
  matches,
}) => {
  const [selectOptions, selectValue, handleChange] = useMultipleValue<
    Region,
    RegionValue,
    RegionOption
  >({
    options: regions,
    key: 'regionCode',
    value,
    onChange,
    createOption: (region: Region): RegionOption => ({
      value: region.regionCode,
      label: [region.offName, region.shortName].filter(Boolean).join(' '),
      matches: matches?.[region.regionCode] || 0,
    }),
  });

  const customProps: CustomProps = useMemo(
    () => ({
      onPlusClick,
    }),
    [onPlusClick],
  );

  const formatOptionLabel = useMatchesLabel<RegionOption>();

  return (
    <Select
      instanceId={instanceId}
      placeholder="Выберите или введите регионы"
      value={selectValue}
      onChange={handleChange}
      options={selectOptions}
      className={className}
      isMulti
      isSearchable
      isClearable={false}
      components={staticProps.components}
      // @ts-ignore
      customProps={customProps}
      appearance={appearance}
      formatOptionLabel={formatOptionLabel}
    />
  );
};
